<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  data() {
    return {
      datacollection: {
        labels: ['', 'SUN 22', 'MON 23', 'TUE 24', 'WEN 25', 'THU 25', 'FRI 26', 'SAT 27', 'SAT 28', ''],
        datasets: [
          {
            label: 'Suppliers',
            borderColor: '#6dcff6',
            backgroundColor: 'rgba(167, 224, 247, .2)',
            pointRadius: 0,
            pointHoverRadius: 0,
            data: [18, 21, 13, 14, 29, 28, 40, 44, 37, 49],
            borderWidth: 1.5,
          },
          {
            label: 'Affiliates',
            borderColor: '#6558fe',
            backgroundColor: 'transparent',
            pointRadius: 0,
            pointHoverRadius: 0,
            data: [25, 15, 18, 23, 13, 22, 28, 44, 47, 40],
            borderWidth: 1.5,
          },
        ],
      },
      options: {
        borderWidth: 2,
        drawBorder: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 4,
              fontColor: '#9baab1',
              fontFamily: "'Proxima Nova', Helvetica, Arial, sans-serif",
            },
            gridLines: {
              color: 'transparent',
              display: true,
              drawBorder: false,
              zeroLineColor: 'rgba(224, 233, 237, 0.6)',
              zeroLineWidth: 1,
            },
            scaleLabel: {
              display: true,
              fontColor: '#9baab1',
              fontFamily: "'Proxima Nova', Helvetica, Arial, sans-serif",
              labelString: 'Property price in USD ($)',
            },
          }],
          xAxes: [{
            gridLines: {
              color: 'transparent',
              display: true,
              drawBorder: false,
              zeroLineColor: 'rgba(224, 233, 237, 0.6)',
              zeroLineWidth: 1,
            },
            ticks: {
              fontColor: '#9baab1',
              fontFamily: "'Proxima Nova', Helvetica, Arial, sans-serif",
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    // renderChart function renders the chart with the datacollection and options object.
    this.renderChart(this.datacollection, this.options);
  },
};
</script>
